import { type PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { MoyasarPaymentForm, logoImage } from '@virtual-care/ui';

interface ServicePaymentProps {
  serviceLabel: string;
  amountLabel: string;
  amountValue: number;
  description: string;
  metadata: Record<string, string>;
  onInitiating: () => Promise<boolean>;
}

export function ServicePayment({
  serviceLabel,
  amountLabel,
  amountValue,
  description,
  metadata,
  onInitiating,
}: ServicePaymentProps) {
  const { t } = useTranslation();
  return (
    <Background>
      <div className="flex h-full flex-col items-center justify-center">
        <div className="min-h-[60vh] w-full max-w-md rounded-lg border bg-white px-4 py-7 shadow">
          <img
            src={logoImage}
            alt={t('payments.logoAlt')}
            className="mx-auto h-[68px] w-[68px] object-contain"
          />
          <p className="mt-5 mb-3 text-center font-bold">{serviceLabel}</p>
          <p className="text-muted-foreground mb-7 flex items-center justify-center gap-1 font-bold">
            {amountLabel}
          </p>
          <MoyasarPaymentForm
            amount={amountValue}
            description={description}
            metadata={metadata}
            onInitiating={onInitiating}
          />
        </div>
      </div>
    </Background>
  );
}

function Background({ children }: PropsWithChildren) {
  return (
    <div className="relative flex h-full min-h-screen w-screen flex-col overflow-hidden bg-[linear-gradient(165deg,#6156d3_50%,white_50%)]">
      <div className="relative z-10 flex h-full flex-col">{children}</div>
    </div>
  );
}
